import { render, staticRenderFns } from "./DinamicModel.vue?vue&type=template&id=48ad8d8a&"
import script from "./DinamicModel.vue?vue&type=script&lang=js&"
export * from "./DinamicModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports